<template>
  <div class="change-company__company">
    <div
      class="change-company__company-card"
      :class="{ active: event.id === company.id }"
      v-for="company in companies"
      :key="company.id"
    >
      <h2 class="change-company__company-card-title">
        {{
          locale === "ru"
            ? company.company.name_rus
            : company.company.name_eng || company.company.name_rus
        }}
      </h2>

      <div class="change-company__company-card-content">
        <div class="change-company__company-card-value">
          <div class="change-company__company-card-value-field">
            <span class="change-company__company-card-value-field-name">
              {{ $t("event.changeCompany.modal.companyProfile") }}
            </span>

            <span class="change-company__company-card-value-field-value">
              <template v-if="hasCompleteCompany(company.company)">
                <DotText class="_success">
                  {{ $t("event.changeCompany.modal.companyProfileFilled") }}
                </DotText>
              </template>

              <template v-else>
                <DotText class="_warning">
                  {{ $t("event.changeCompany.modal.companyProfileNotFilled") }}
                </DotText>
              </template>
            </span>
          </div>

          <div class="change-company__company-card-value-field">
            <span class="change-company__company-card-value-field-name">
              {{ $t("event.changeCompany.modal.catalogApplication") }}
            </span>

            <span class="change-company__company-card-value-field-value">
              <template v-if="company.catalog_order_status !== 'draft'">
                <DotText class="_success">
                  {{ $t("event.changeCompany.modal.catalogApplicationSent") }}
                </DotText>
              </template>

              <template v-else>
                <DotText class="_warning">
                  {{
                    $t("event.changeCompany.modal.catalogApplicationNotSent")
                  }}
                </DotText>
              </template>
            </span>
          </div>

          <div class="change-company__company-card-value-field">
            <span class="change-company__company-card-value-field-name">
              {{ $t("event.changeCompany.modal.participantPasses") }}
            </span>

            <span class="change-company__company-card-value-field-value">
              {{ company.quota?.certificate_count || 0 }}
              {{ locale === "en" ? "out of" : "из" }}
              {{
                company.quota && company.quota.certificate
                  ? company.quota.certificate
                  : 0
              }}
            </span>
          </div>

          <div class="change-company__company-card-value-field">
            <span class="change-company__company-card-value-field-name">
              {{ $t("event.changeCompany.modal.carPasses") }}
            </span>

            <span class="change-company__company-card-value-field-value">
              {{ company.car_passes_count }}
            </span>
          </div>
        </div>

        <div class="change-company__company-card-form">
          <PrimaryButton
            type="button"
            :disabled="event.id === company.id"
            @click="choseCompany(company.id)"
          >
            {{ $t("common.selectBtn") }}
          </PrimaryButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiParticipant from "@/api/participant";
import hasCompleteCompany from "@/helpers/event";
import { PrimaryButton, DotText } from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";

export default {
  components: {
    DotText,
    PrimaryButton
  },

  props: ["companies"],

  computed: {
    locale() {
      return i18n.locale;
    },
    ...mapState("event", ["event"])
  },

  methods: {
    async choseCompany(id) {
      await apiParticipant.makePrimary(id);
      window.location.replace(`/participant/${id}`);
    },

    hasCompleteCompany(company) {
      return hasCompleteCompany(company);
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.change-company__company {
  margin: 16px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 780px;
  width: 100%;

  &-card {
    border-radius: 2px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border: 1px solid #f1f1f1;

    max-width: 380px;
    width: 100%;

    margin-bottom: 24px;

    @include respond-down(lg) {
      max-width: 350px;
    }

    @media (min-width: 740px) and (max-width: 767px) {
      max-width: 330px;
    }

    @include respond-down(md) {
      max-width: 100%;
    }

    &-content {
      padding: 0 0 32px 0;
      @include respond-down(md) {
        &_open {
          display: none;
        }
      }
    }

    &-title {
      font-size: 16px;
      font-weight: 400;

      line-height: 1.5;

      color: #505050;
      padding: 14px 31px 8px 26px;
      margin: 0 0 0 0;

      height: 80px;

      display: flex;
      align-items: center;
      box-sizing: border-box;
      background-color: #f1f1f1;

      svg {
        display: none;
      }

      @include respond-down(md) {
        svg {
          display: block;
        }
        justify-content: space-between;

        font-size: 14px;

        padding: 16px 24px 20px 24px;
        height: auto;
        box-sizing: border-box;

        &_open .svg-icon {
          transform: rotate(-180deg);
        }
      }
    }

    &-status {
      background-color: rgba(241, 241, 241, 0.5);
      padding: 17px 0 20px 32px;
      display: flex;
      align-items: flex-start;

      @include respond-down(md) {
        padding: 17px 24px 24px 24px;
        justify-content: space-between;
      }

      &-account {
        &-inf {
          font-size: 13px;
          line-height: 1.54;
          color: #000000;
          margin: 0 0 0 0;

          @include respond-down(md) {
            font-size: 12px;
          }
        }

        &-action {
          font-size: 12px;
          line-height: 1.5;
          color: #a3a8b3;
          margin: 5px 0 0 0;

          max-width: 170px;

          @include respond-down(md) {
            font-size: 11px;
          }
        }
        &_activated {
          margin-left: 23px;
        }
      }

      &-btn {
        max-width: 120px;
        display: flex;
        text-align: left;
        border: none;
        outline: none;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.67;
        color: #a3a8b3;
        background-color: transparent;
        padding: 0 0 0 0;
        margin: 3px 0 0 20px;

        @include respond-down(md) {
          font-size: 10px;
          margin: 0;
          width: 75px;
        }

        .svg-icon {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          color: #a3a8b3;
          margin: 1px 9px 0 0;
          padding: 0 0 0 0;
        }
      }
    }

    &-value {
      padding: 0 32px 0 32px;
      margin: 13px 0 0 0;

      @include respond-down(md) {
        padding: 0 24px;
      }

      &-field {
        border-bottom: 1px solid #f1f1f1;
        padding: 13px 0 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-name {
          font-size: 13px;
          line-height: 1.54;
          @include respond-down(md) {
            font-size: 12px;
          }
        }

        &-value {
          width: 113px;
          color: #6d7179;
          font-size: 13px;

          @include respond-down(md) {
            font-size: 12px;
          }
        }
      }
    }

    &-form {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 32px 0 32px;
      margin: 20px 0 0 0;
    }

    &.active & {
      &-title {
        background-color: #009ee3;
        color: #ffffff;
      }
    }
  }
}
</style>
